import saga from './saga';
import reducer from './reducer';

export default {
  reducer,
  saga
};
